<template>
  <div>
    <step :navItems="navItems" :index="1" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/exam-mgr') }">
      <template slot="header">
        <h3>考試作業清單名稱</h3>
      </template>

      <template slot="body">
        <div class="row">
          <div class="col-sm-4 offset-sm-4">
            <form class="form-custom pt-0 bg-white">
              <label for="inputOldPassword" class="sr-only">考試作業清單名稱</label>
              <input type="text" class="form-control mt-3 rounded" :placeholder="'請輸入名稱...(限制10個字)'" required v-model="name">
            </form>
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="2" :step="step" v-on:step="updateStep">
      <template slot="header">
        <div class="row">
          <div class="col-sm-4 offset-sm-4" style="font-size: 24px;">{{ name }}</div>
          <div class="col-sm-4">
            <span class="btn btn-xs p-0 text-danger">
              <img src="~../../assets/image/icon/lock.png" /> 考試僅提供單選
            </span>
          </div>
        </div>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2">
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between border mb-3 rounded"
                :class="{ 'active': getSelectedIdx(item.id) > -1 }"
                style="line-height: 300%;"
                v-for="item in exams"
                @click="select(item)">
                <div class="d-flex align-items-center mr-auto">
                  <span v-html="forceToJap(item.name)"></span><br>{{ item.localName }}
                </div>
                <div class="ml-auto">
                  <span class="p-0 pl-3 pr-3 text-white btn-category content" v-if="item.language">{{ item.language }}</span>
                  <span class="p-0 pl-3 pr-3 text-white btn-category user-target" v-if="item.categoryName">{{ item.categoryName }}</span>
                  <span class="p-0 pl-3 pr-3 text-white btn-category level" v-if="item.level">{{ item.level }}</span>
                </div>
              </li>
            </ul>

            <pagination class="mt-3" :current="pageIndex" :total="pageCount" v-on:page="updatePage" v-if="switchOn" />
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="3" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/exam-mgr') }" v-on:finish="() => { this.$router.push('/exam-mgr') }">
      <template slot="header">
        <h3>完成</h3>
      </template>

      <template slot="body">
        <div class="col-8 offset-2">
          <ul class="list-group list-group-flush">
            <li class="list-group-item d-flex justify-content-between border text-left mb-3 rounded">
              <div class="d-flex mr-auto">
                {{ name }}<br>建立時間：{{ createTime }}
              </div>
              <div class="d-flex align-items-center ml-auto">
                共 {{ selected.length }} 考卷
              </div>
            </li>
          </ul>
        </div>
      </template>
    </step>
  </div>
</template>

<script>
import lessonFilterMixin from '../../components/lessonFilterMixin'
import langMixin from '../../components/langMixin'
import Pagination from '../../components/Pagination'
import Step from './Step'
import api from '../../store/api'
import selectMixin from './selectMixin'

export default {

  name: 'TeachingExamEditor',

  components: {
    Pagination,
    Step
  },

  mixins: [lessonFilterMixin, langMixin, selectMixin],

  data () {
    return {
      step: 1,
      switchOn: true,
      examId: null,
      name: '',
      createTime: '',
      defaultTitle: {
        language: '語言',
        category: '類別',
        level: '等級'
      },
      navItems: ['新增或選擇清單', '輸入名稱', '選擇考試', '完成'],
      list: [],
      pageIndex: 1,
      pageCount: 0
    }
  },

  computed: {
    mode () {
      return (this.$route.name === 'exam-mgr.add') ? 'add' : 'edit'
    },

    exams () {
      return this.switchOn ? this.list : this.selected
    }
  },

  async mounted () {
    this.examId = this.$route.params.examId
    this.getExamList()

    if (this.examId) {
      const { data } = await api.get('/ExamMgr/TeachingExams/' + this.examId)

      if (data.status === 'OK') {
        this.name = data.data.name

        let self = this
        api.get('/ExamMgr/TeachingExams/' + this.examId + '/ExamPapers')
          .then((res) => {
            self.selected = res.data.data
          })
      }
    }
  },

  methods: {
    async getExamList (params) {
      const { data } = await api.get('/ExamPaperMgr/ExamPapers', { params: params })

      if (data.status === 'OK') {
        this.list = data.data
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    updatePage (page) {
      this.getExamList({
        'pageIndex': page
      })
    },

    updateStep (step) {
      this.step = step

      if (step === 3) {
        this.createExam()
      }
    },

    async createExam () {
      let fileData = new window.FormData()
      fileData.append('name', this.name)

      const { data } = await api.post('/ExamMgr/TeachingExams', fileData)

      if (data.status === 'OK') {
        this.createTime = data.data.createTime
        this.addPaperToExam(data.data.id)
      }
    },

    async addPaperToExam (examId) {
      let examForm = new window.FormData()
      examForm.append('examPaperIds', this.selected)

      const { data } = await api.post('ExamMgr/TeachingExams/' + examId + '/ExamPapers', examForm)

      if (data.status === 'OK') {
        console.log('Success')
      }
    },

    select (item) {
      this.selected.splice(0, this.selected.length)
      this.selected.push(item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

.list-group-item.active {
  background-color: $main-color;
}
</style>


// WEBPACK FOOTER //
// TeachingExamEditor.vue?27a35904